// components/ServerDatabase/ServerStatsBanner.jsx
import React from 'react';

const ServerStatsBanner = ({ onRefresh, loading, hoveredServer }) => {
  const stats = [
    { value: "47", label: "Available Servers", color: "text-accent-blue" },
    { value: "42%", label: "Online Servers", color: "text-accent-green" },
    { value: "43%", label: "Vulnerable Servers", color: "text-accent-yellow" },
    { 
      value: hoveredServer ? hoveredServer.ip : "2 min", 
      label: hoveredServer ? "Hovered Server" : "Last Update", 
      color: hoveredServer ? "text-accent-purple" : "text-accent-pink" 
    }
  ];

  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <div className="relative overflow-hidden bg-gradient-to-r from-dark-500 to-dark-400 rounded-2xl p-6 border border-dark-400 hover:border-accent-purple/30 transition-medium">
        {/* Background effects */}
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent-purple opacity-5 rounded-full blur-3xl"></div>
        <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-accent-blue opacity-5 rounded-full blur-3xl"></div>
        
        <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
          <div className="w-full md:w-1/2 mb-6 md:mb-0">
            <div className="text-sm font-medium text-accent-blue mb-2 animate-pulse-slow">
              SERVER DATABASE
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold mb-3 group">
              Available<span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text">Servers</span> to Hack
            </h2>
            <p className="text-gray-400 mb-6 text-sm max-w-md">
              Browse our database of available servers to test with instant connection. 
              Updated every 30 minutes.
            </p>
            <button
              onClick={onRefresh}
              disabled={loading}
              className="bg-gradient-to-r from-accent-blue to-accent-purple text-white px-6 py-3 rounded-xl hover:shadow-glow active:translate-y-0.5 transform-gpu transition-medium font-medium whitespace-nowrap group disabled:opacity-50"
            >
              <i className={`fas fa-sync-alt mr-2 ${loading ? 'animate-spin' : 'group-hover:rotate-180 transition-medium'}`}></i>
              Refresh List
            </button>
          </div>
          <div className="w-full md:w-1/2 grid grid-cols-2 gap-3 max-w-md">
            {stats.map((stat, index) => (
              <StatCard 
                key={index} 
                {...stat} 
                loading={loading}
                isHovered={hoveredServer && index === 3}
              />
            ))}
          </div>
        </div>
        
        {/* Floating server icon */}
        <div className="absolute right-0 bottom-0 opacity-10 hover:opacity-20 transition-medium animate-float transform-gpu">
          <i className="fas fa-server text-6xl sm:text-9xl"></i>
        </div>
      </div>
    </div>
  );
};

const StatCard = ({ value, label, color, loading, isHovered }) => (
  <div className={`bg-dark-500 p-4 rounded-xl transform-gpu transition-medium ${
    isHovered ? 'scale-105 shadow-md border border-accent-purple/30' : 'hover:scale-[1.03] hover:bg-dark-400'
  }`}>
    {loading ? (
      <div className="animate-pulse">
        <div className={`h-6 w-3/4 mb-2 rounded ${color.replace('text-', 'bg-')}/20`}></div>
        <div className="h-4 w-1/2 rounded bg-dark-400"></div>
      </div>
    ) : (
      <>
        <div className={`text-xl sm:text-2xl font-bold mb-1 ${color} transition-medium ${
          isHovered ? 'animate-pulse-text' : ''
        }`}>{value}</div>
        <div className="text-xs text-gray-400 group-hover:text-gray-300 transition-medium">{label}</div>
      </>
    )}
  </div>
);

export default ServerStatsBanner;